import { Skeleton, Typography } from "@mui/material"

import { groupBy } from "../../../../helpers/helpers";
import MuiInput from "../../../../components/mui-input/MuiInput";
import { StyledAddCustomer } from "./AddCustomer.styled";
import { UseFormReturn } from "react-hook-form";
import { AccountAdd } from "../../../../models/account";
import { useGetAccountStructureQuery } from "../../../../redux/api/accounts-structure.api";
import { useTheme } from "@emotion/react";


interface AddCustomerProps {
  useForm: UseFormReturn<AccountAdd>
}

function AddCustomer({ useForm }: AddCustomerProps) {
  
  const theme = useTheme();

  const { 
    data: customerStructure,
    isFetching,
  } = useGetAccountStructureQuery("לקוח-ספק");

  const structureSortedByTitle = groupBy(customerStructure, "account_title")
  const customFieldsExist = structureSortedByTitle?.["מותאם אישית"]?.find(structure=> !!structure.show_form === true);


  return (
    <StyledAddCustomer>
      {isFetching && (<Skeleton variant="rectangular" height={500} animation="wave" sx={{ bgcolor: theme.colors.section_color }} />)}
      {!isFetching && customerStructure &&
        <>
          <div>
            <Typography variant="body1">פרטים</Typography>
            <div className="fields">
              {structureSortedByTitle?.["פרטים"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            <Typography variant="body1">פרטי קשר</Typography>
            <div className="fields">
              { structureSortedByTitle?.["פרטי קשר"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            {customFieldsExist && (<Typography variant="body1">שדות מותאמים אישית:</Typography>)}
            <div className="fields">
              { structureSortedByTitle?.["מותאם אישית"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

        </>}

    </StyledAddCustomer>
  )
}

export default AddCustomer